import { SET_WORKOUTS, SET_WORKOUT_BY_ID, RESET_WORKOUT_BY_ID } from './workoutsTypes';

const initialState = {
	list: [],
	currentWorkout: null,
	loading: false,
};

export const workoutsReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_WORKOUTS:
			return { ...state, list: action.payload };
		case SET_WORKOUT_BY_ID:
			console.log('Setting current workout in reducer:', action.payload);
			return { ...state, currentWorkout: action.payload };
		case RESET_WORKOUT_BY_ID:
			return { ...state, currentWorkout: null };
		default:
			return state;
	}
};
